const CONSOLE_RESOURCE = {
  partition: '*',
  region: '*',
  project: '*',
  serviceType: 'iam',
  service: 'console',
  instance: '*',
  actions: ['display']
};

const PRODUCT_MANAGEMENT_RESOURCE = {
  partition: '*',
  region: '*',
  project: '*',
  serviceType: 'product',
  service: 'console',
  instance: 'management',
  actions: ['display']
};

const PRIVILEGED_CONSOLE_RESOURCE = {
  partition: '*',
  region: '*',
  project: '*',
  serviceType: 'iam',
  service: 'privileged-account',
  instance: '*',
  actions: ['create', 'update', 'write', 'read']
};

const PRIVILEGE_CHECKIN_CONSOLE_RESOURCE = {
  partition: '*',
  region: '*',
  project: '*',
  serviceType: 'iam',
  service: 'privilege-checkin-console',
  instance: '*',
  actions: ['display']
};

const PRIVILEGE_CHECKIN_TEAM_RESOURCE = {
  partition: '*',
  region: '*',
  project: '*',
  serviceType: 'iam',
  service: 'privilege-checkin-team',
  instance: '*',
  actions: ['create']
};

const PRIVILEGE_CHECKIN_ALL_HISTORY_RESOURCE = {
  partition: '*',
  region: '*',
  project: '*',
  serviceType: 'iam',
  service: 'privilege-checkin',
  instance: '*',
  actions: ['read-all']
};

const ACTIONS_MAP = {
  console: {
    resource: CONSOLE_RESOURCE
  },
  productManagement: {
    resource: PRODUCT_MANAGEMENT_RESOURCE
  },
  privilegedConsole: {
    resource: PRIVILEGED_CONSOLE_RESOURCE
  },
  privilegeCheckinConsole: {
    resource: PRIVILEGE_CHECKIN_CONSOLE_RESOURCE
  },
  privilegeCheckinTeam: {
    resource: PRIVILEGE_CHECKIN_TEAM_RESOURCE
  },
  privilegeCheckinAllHistory: {
    resource: PRIVILEGE_CHECKIN_ALL_HISTORY_RESOURCE
  }
};

// eslint-disable-next-line import/prefer-default-export
export { ACTIONS_MAP };
